import { FC } from 'react';
import { useIntl } from 'react-intl';
import { CalculatorCurrencyField, CalculatorDoubleSelect } from 'components/common';
import { CalculatorFormControl } from 'components/common/CalculatorFormControl';
import { generateArrayOfNumbers } from 'utils';
import { ContractorFieldsQuestions } from './questions';
import { ContractorFieldsProps } from './types';

export const ContractorFields: FC<ContractorFieldsProps> = ({
  applicantNumber,
  incomeType,
  isTimeTradingMoreThanTwoYears,
}) => {
  const intl = useIntl();
  const { timeTrading, netTaxableIncomePreviousYear, netTaxableIncomeRecentYear, timeRemaining, error } =
    ContractorFieldsQuestions;
  const yearsOptions = generateArrayOfNumbers(0, 20).map(year => ({ value: year, label: String(year) }));
  const monthsOptions = generateArrayOfNumbers(0, 11).map(month => ({ value: month, label: String(month) }));

  return (
    <>
      <CalculatorFormControl
        name={`applicants[${applicantNumber}].${incomeType}.timeTrading`}
        rules={{ required: intl.formatMessage({ id: error.required }) }}
        titleKey={timeTrading.titleKey}
        textKey={timeTrading.textKey}
        radioOptions={timeTrading.options}
        className={'xs:mb-5 md:mb-10'}
        isWide
      />
      <CalculatorDoubleSelect
        className={'xs:mb-5 md:mb-10'}
        rules={{ required: intl.formatMessage({ id: error.required }) }}
        names={[
          `applicants[${applicantNumber}].${incomeType}.timeRemainingYears`,
          `applicants[${applicantNumber}].${incomeType}.timeRemainingMonths`,
        ]}
        textKey={timeRemaining.textKey}
        titleKey={timeRemaining.titleKey}
        options={[yearsOptions, monthsOptions]}
        placeholdersKeys={timeRemaining.placeholdersKeys}
      />
      <CalculatorCurrencyField
        name={`applicants[${applicantNumber}].${incomeType}.netTaxableIncomeRecentYear`}
        rules={{ required: intl.formatMessage({ id: error.required }) }}
        titleKey={netTaxableIncomeRecentYear.titleKey}
        className={'xs:mb-5 md:mb-10'}
      />
      {isTimeTradingMoreThanTwoYears && (
        <CalculatorCurrencyField
          name={`applicants[${applicantNumber}].${incomeType}.netTaxableIncomePreviousYear`}
          rules={{ required: intl.formatMessage({ id: error.required }) }}
          titleKey={netTaxableIncomePreviousYear.titleKey}
          className={'xs:mb-5 md:mb-12'}
        />
      )}
    </>
  );
};
